import React, { PropTypes } from 'react';
import { Col, FormGroup } from 'react-bootstrap';
import AgentCodeName from '../agentCodeName/AgentCodeName'
import ProposerType from '../proposerType/ProposerType';
import QuotationNo from '../quotationNo/QuotationNo';
import InsuredName from '../insuredName/InsuredName';
import QuotationDate from '../quotationDate/QuotationDate';
import IdNo from '../idNo/IdNo';

const RequestInfo = (props) => {
  return (
    <div className="ebaoUtil__Top-Bottom-Line">
      <h3 className="ebaoUtil__HeaderThree">Request Information</h3>
      <FormGroup controlId="agentCodeNameProposerType">
        <Col sm={6}>
          <AgentCodeName
             agentCode={props.requestInfo.agentCode}
             agentName={props.requestInfo.agentName}
             handleGetAgentName={props.handleGetAgentName}
             handleChangeAgentCode={props.handleChangeAgentCode}
             systemRole={props.role}
             required
          />
        </Col>
        <Col sm={6}>
          <ProposerType
            proposerType={props.requestInfo.proposerType}
            handleChangeProposerType={props.handleChangeRequestInfo}
            proposerTypeId="proposerType"
          />
        </Col>
      </FormGroup>
      <FormGroup controlId="quotationNoIssuedName">
        <Col sm={6}>
          <QuotationNo
            handleChangeQuotationNo={props.handleChangeRequestInfo}
            quotationNo={props.requestInfo.quotationNo}
          />
        </Col>
        <Col sm={6}>
          <InsuredName
            insuredName={props.requestInfo.insuredName}
            handleChangeInsuredName={props.handleChangeRequestInfo}
            required={props.insuredNameRequired}
          />
        </Col>
      </FormGroup>
      <FormGroup controlId="quotationDateIdNo">
        <Col sm={6}>
          <QuotationDate
            quotationDate={props.requestInfo.quotationDate}
            handleChangeQuotationDate={props.handleChangeRequestInfo}
          />
        </Col>
        <Col sm={6}>
          <IdNo
            id={props.requestInfo.id}
            handleChangeIdNo={props.handleChangeRequestInfo}
          />
        </Col>
      </FormGroup>
    </div>
  )
}

RequestInfo.propTypes = {
  requestInfo: PropTypes.object,
  handleChangeRequestInfo: PropTypes.func,
  handleGetAgentName: PropTypes.func,
  handleChangeAgentCode: PropTypes.func,
  role: PropTypes.string,
  insuredNameRequired: PropTypes.bool
};

export default RequestInfo;



// WEBPACK FOOTER //
// ./src/app/components/requestInfo/RequestInfo.js